import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Login from "../components/Login/Login";
import { fetchAccessToken, fetchUserData, verifyOtp, resendOtp } from "../actions/user";

const mapStateToProps = (state) => {
  const { login } = state;
  const {
    isFetching,
    otpToken,
    accessToken,
    refreshToken,
    errorCode,
    errorMessage,
    maintenance,
    screen_message,
  } = login || {
    isFetching: true,
    errorCode: null,
    errorMessage: "",
  };
  return {
    isFetching,
    otpToken,
    accessToken,
    refreshToken,
    errorCode,
    errorMessage,
    maintenance,
    screen_message,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchAccessToken,
      fetchUserData,
      verifyOtp,
      resendOtp,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Login);
